<template>
  <div class="app-container">
    <div class="head-container">
      <a-collapse
        v-model="filterActiveKeys"
        :bordered="false"
        class="log-filter-collapse"
      >
        <a-collapse-panel key="filters" :show-arrow="false">
          <template slot="header">
            <div class="log-filter-header">
              <span class="log-filter-title">
                <a-icon type="filter" />
                筛选条件
              </span>
              <span class="log-filter-actions" @click.stop>
                <template v-if="isFilterExpanded">
                  <a-button
                    :disabled="
                      queryFuncName !== '' && checkOperateDisable(queryFuncName)
                    "
                    :loading="crud.loading"
                    size="small"
                    type="primary"
                    @click="crud.toQuery()"
                  >
                    查询
                  </a-button>
                  <a-button
                    :disabled="
                      queryFuncName !== '' && checkOperateDisable(queryFuncName)
                    "
                    size="small"
                    @click="crud.resetQuery()"
                  >
                    重置
                  </a-button>
                </template>
                <a-button
                  class="log-filter-toggle"
                  size="small"
                  type="link"
                  @click="toggleFilterPanel"
                >
                  {{ isFilterExpanded ? "收起" : "展开筛选" }}
                  <a-icon :type="isFilterExpanded ? 'up' : 'down'" />
                </a-button>
              </span>
            </div>
          </template>
          <a-form class="log-filter-form" layout="inline">
            <a-row :gutter="16">
              <a-col :md="3" :sm="24">
                <a-form-item label="操作模块">
                  <a-select
                    v-model="crud.query.domainName"
                    :allowClear="true"
                    :filterOption="filterCategory"
                    placeholder="请选择分类"
                    show-search
                  >
                    <a-select-option
                      v-for="item in [...domainNames]"
                      :key="item"
                      :value="item"
                      >{{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="3" :sm="24">
                <a-form-item label="功能模块">
                  <a-select
                    v-model="crud.query.functionName"
                    :allowClear="true"
                    :filterOption="filterCategory"
                    placeholder="请选择分类"
                    show-search
                  >
                    <a-select-option
                      v-for="item in [...functionNames]"
                      :key="item"
                      :value="item"
                      >{{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="3" :sm="24">
                <a-form-item label="操作类型">
                  <a-select
                    v-model="crud.query.operateType"
                    :allowClear="true"
                    :filterOption="filterCategory"
                    placeholder="请选择分类"
                    show-search
                  >
                    <a-select-option
                      v-for="item in [...operateTypeNames]"
                      :key="item"
                      :value="item"
                      >{{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="3" :sm="24">
                <a-form-item label="操作人">
                  <a-select
                    v-model="crud.query.userID"
                    :allowClear="true"
                    :filterOption="filterCategory"
                    placeholder="请选择分类"
                    show-search
                  >
                    <a-select-option
                      v-for="item in [...allUserListMap]"
                      :key="item.userID"
                      :value="item.userID"
                      >{{ item.displayName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="4" :sm="24">
                <a-form-item label="操作时间">
                  <a-range-picker
                    v-model="crud.query.operateTime"
                    :allowClear="true"
                    :show-time="showTime()"
                    allow-clear
                    format="YYYY-MM-DD HH:mm:ss"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="4" :sm="24">
                <a-form-item label="操作内容">
                  <a-input
                    v-model.trim="crud.query.content"
                    allow-clear
                    placeholder="请输入操作内容"
                    @pressEnter="crud.toQuery()"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="4" :sm="24">
                <a-form-item label="旧数据">
                  <a-input
                    v-model.trim="crud.query.oldContent"
                    allow-clear
                    placeholder="请输入旧数据内容"
                    @pressEnter="crud.toQuery()"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <div class="table-container">
      <Operations tableName="日志" />
      <a-spin :spinning="crud.loading">
        <a-table
          :bordered="true"
          :columns="crud.columns"
          :data-source="crud.data"
          :pagination="false"
          :row-class-name="
            (_record, index) => (index % 2 === 1 ? 'table-striped' : null)
          "
          :scroll="{ x: crud.props.scrollX || 3000 }"
          class="ant-table-striped"
          empty-text="-"
          rowKey="logID"
          @resizeColumn="
            (w, col) => {
              col.width = w
            }
          "
        >
          <template slot="operateTime" slot-scope="record">
            {{ filterTime(record.operateTime) }}
          </template>
        </a-table>
      </a-spin>
      <Pagination />
    </div>
    <!-- 填写表单部分 -->
    <div class="draw-container">
      <a-modal
        :afterClose="
          () => {
            form = {}
            crud.refresh()
          }
        "
        :title="crud.status.title"
        :visible="crud.status.cu > 0 || crud.status.in > 0"
        wrapClassName="stationListDialog"
        @cancel="crud.cancelCU()"
      >
        <a-form-model
          ref="form"
          :class="
            crud.status.in > 0 && crud.status.cu === 0 ? 'disabled-form' : ''
          "
          :label-col="{ span: 6 }"
          :model="form"
          :rules="rules"
          :wrapper-col="{ span: 18 }"
          labelAlign="left"
        >
          <a-form-model-item label="关键字" prop="value">
            <a-input
              v-model="form.value"
              :disabled="crud.status.in > 0 && crud.status.cu === 0"
            />
          </a-form-model-item>

          <a-form-model-item
            v-if="form.creatorID && form.creatorID > 0"
            label="创建者"
            prop="creator"
          >
            <a-input v-model="form.creator" :disabled="true" />
          </a-form-model-item>
          <a-form-model-item
            v-if="form.creatorID && form.creatorID > 0"
            label="最近修改日期"
            prop="updateTime"
          >
            {{ filterTime(form.updateTime) }}
          </a-form-model-item>
          <a-form-model-item
            v-if="form.creatorID && form.creatorID > 0"
            label="创建日期"
            prop="insertTime"
          >
            {{ filterTime(form.insertTime) }}
          </a-form-model-item>
        </a-form-model>
        <template slot="footer">
          <div v-if="crud.status.cu > 0">
            <a-button
              v-if="crud.status.add > 0"
              key="back"
              @click="crud.cancelCU()"
            >
              取消
            </a-button>
            <a-button
              v-if="crud.status.edit > 0"
              key="back"
              @click="crud.cancelCU('uptoinfo')"
            >
              取消
            </a-button>
            <a-button
              v-if="crud.status.add > 0"
              key="submit"
              type="primary"
              @click="crud.submitCU()"
            >
              提交
            </a-button>
            <a-button
              v-if="crud.status.edit > 0"
              key="submit"
              type="primary"
              @click="editSaveKeyword"
            >
              保存
            </a-button>
          </div>
          <div v-if="crud.status.in > 0 && crud.status.cu === 0">
            <a-button
              key="back"
              :disabled="!crud.permission.edit"
              @click="crud.toEdit()"
            >
              修改
            </a-button>
            <a-popconfirm
              cancel-text="取消"
              ok-text="删除"
              placement="topRight"
              @confirm="crud.doDelete(null, 'close')"
            >
              <template slot="title">
                你确定要删除吗？
              </template>
              <a-button
                key="submit"
                :disabled="!crud.permission.del"
                type="danger"
              >
                删除
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import Operations from "@/components/Crud/Operations"
import Pagination from "@/components/Crud/Pagination"
import CRUD, { form, header, presenter } from "@crud/crud"
import Api, { GetFilterPattern } from "@/api/log/index"
import { fullTimeFilter } from "@/utils/utils"
import store from "@/store"
import { GetAllUserList } from "@/api/public-api"
import { LogListColumns } from "@/views/log/list"
import { LogDomainArr, LogFunctionArr, LogOperateType } from "@/config"
import { checkOperateDisable } from "@/router/permission"
import dayjs from "dayjs"

// 表格的填充字段
const defaultForm = {}
export default {
  name: "log",
  // presenter 生成crud对象
  mixins: [presenter(), header(), form(defaultForm)],
  cruds() {
    return CRUD({
      title: "日志",
      roleIDs: [],
      columns: LogListColumns,
      crudMethod: { ...Api },
      query: {
        content: "",
        oldContent: ""
      },
      idField: "keywordID" // 设置每一条记录的唯一标失
    })
  },
  data() {
    return {
      allUserListMap: [],
      filterActiveKeys: ["filters"],
      LogDomainArr,
      LogFunctionArr,
      LogOperateType,
      queryFuncName: "查询日志列表",
      domainNames: [],
      functionNames: [],
      operateTypeNames: [],
      rules: {
        value: [{ required: true, message: "请输入关键字", trigger: "blur" }]
      }
    }
  },
  components: { Operations, Pagination },
  computed: {
    isFilterExpanded() {
      return Array.isArray(this.filterActiveKeys)
        ? this.filterActiveKeys.includes("filters")
        : this.filterActiveKeys === "filters"
    }
  },
  async created() {
    const that = this
    /**
     * 设置按钮权限
     */
    // 关闭下载功能
    // this.crud.optShow.download = false
    this.crud.optShow.edit = false
    // 显示以下按钮
    this.crud.permission = {
      add: false,
      del: false,
      edit: false
      // download: true
    }

    this.addOk = false

    const [getAllUserListRes, getFilterPatternRes] = await Promise.all([
      GetAllUserList(),
      GetFilterPattern()
    ])

    if (getAllUserListRes.code === 0) {
      this.allUserListMap = [...getAllUserListRes.result]
    }

    if (getFilterPatternRes.code === 0) {
      that.domainNames = getFilterPatternRes.result.domainName
      that.functionNames = getFilterPatternRes.result.functionName
      that.operateTypeNames = getFilterPatternRes.result.operateTypeName
    }

    this.roleIDs = store.getters.roleIDs
  },
  methods: {
    filterTime: timeStr => fullTimeFilter(timeStr),
    checkOperateDisable,
    toggleFilterPanel() {
      this.filterActiveKeys = this.isFilterExpanded ? [] : ["filters"]
    },
    showTime() {
      return { defaultValue: dayjs("00:00:00", "HH:mm:ss") }
    },
    startTimeChange(dates, dateStrings) {
      if (dateStrings[0] && dateStrings[1]) {
        let time1 = dateStrings[0]
        let time2 = dateStrings[1]
        if (
          new Date(time2.replace(/-/g, "/")).getTime() / 1000 -
            (new Date(time1.replace(/-/g, "/")).getTime() / 1000 +
              24 * 60 * 60) >
          365 * 24 * 60 * 60
        ) {
          this.$message.info("请选择一年内的时间！")
          this.crud.query.startTimes = [time1, time1]
          return
        }
      }
      this.crud.query.startTimes = dateStrings
    },
    toInfo(record) {
      this.crud.toInfo(record)
      if (record.users && record.users.length > 0) {
        record.userID = record.users[0].userID
        record.userType = record.users[0].userType
      }

      this.form = JSON.parse(JSON.stringify(record))
      this.currentInfo = JSON.parse(JSON.stringify(record))
      this.activeKey = 1
    },
    filterCategory: function(value, option) {
      return option.componentOptions.children[0].text.indexOf(value) >= 0
    },
    async editSaveKeyword() {
      const res = await Api.edit({
        keywordID: this.form.keywordID,
        value: this.form.value
      })
      if (res.code === 14) {
        this.$message.success("更改成功")
        this.crud.cancelCU("uptoinfo")
      }
    }
  }
}
</script>

<style scoped>
.ant-table-striped ::v-deep .table-striped td {
  background-color: #fcfcfc;
}

.log-filter-collapse {
  background: transparent;
}

.log-filter-collapse ::v-deep .ant-collapse-item {
  border-bottom: 0;
}

.log-filter-collapse ::v-deep .ant-collapse-header {
  padding: 10px 16px;
}

.log-filter-collapse ::v-deep .ant-collapse-content {
  border-top: 1px solid #eef1f5;
}

.log-filter-collapse ::v-deep .ant-collapse-content-box {
  padding: 14px 16px 2px;
}

.log-filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 28px;
}

.log-filter-title {
  color: #1f2d3d;
  font-size: 14px;
  font-weight: 600;
}

.log-filter-title .anticon {
  margin-right: 8px;
  color: #1890ff;
}

.log-filter-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.log-filter-toggle {
  padding-right: 0;
}

.log-filter-toggle .anticon {
  margin-left: 4px;
}

.log-filter-form ::v-deep .ant-form-item {
  margin-bottom: 12px;
}
</style>
